(() => {
  /* Gallery fit: always contain. No soft zoom, no cover crop.
     Letterbox beats cutting product edges (KT3400T, Schneider, etc.). */
  const section = document.querySelector('.shopify-section-main-product');
  if (!section) return;

  let timer = 0;

  function forceContain(root) {
    if (!root) return;
    root.querySelectorAll('.media-item').forEach((item) => {
      if (item.dataset.fit !== 'contain') item.dataset.fit = 'contain';
      item.style.removeProperty('--fit-scale');
    });
  }

  function run() {
    forceContain(section.querySelector('.main-gallery'));
    forceContain(section.querySelector('.thumbnail-gallery'));
  }

  function schedule() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      timer = 0;
      window.requestAnimationFrame(run);
    }, 80);
  }

  function whenImagesReady() {
    const imgs = section.querySelectorAll('.main-gallery img, .thumbnail-gallery img');
    const pending = [];
    imgs.forEach((img) => {
      if (img.complete && img.naturalWidth) return;
      pending.push(
        img.decode
          ? img.decode().catch(() => {})
          : new Promise((resolve) => {
              img.addEventListener('load', resolve, { once: true });
              img.addEventListener('error', resolve, { once: true });
            })
      );
    });
    if (!pending.length) {
      run();
      return;
    }
    Promise.all(pending).then(run);
  }

  whenImagesReady();
  window.addEventListener('load', run, { once: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });

  const main = section.querySelector('.main-gallery');
  if (main) {
    new MutationObserver(schedule).observe(main, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class', 'data-fit'],
    });
  }
})();
